// extracted by mini-css-extract-plugin
export var createdDate = "_kw-1";
export var divider = "_kw-2";
export var headerDivider = "_kw-3";
export var messagesCard = "_kw-0";
export var messagesContainer = "_kw-7";
export var messagesContainerWrapper = "_kw-4";
export var pointerCapturingButtonBoxes = "_kw-a";
export var showLeftPanelButton = "_kw-9";
export var showMoreButton = "_kw-c";
export var showMoreButtonContainer = "_kw-b";
export var summaryTitle = "_kw-6";
export var systemMessageCardWrapper = "_kw-d";
export var topButtons = "_kw-8";
export var withPadding = "_kw-5";